import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import { MutationTemporarilyBanBannerArgs, TemporarilyBanBannerPayload } from '@hdms/shared/common-types';

interface TemporarilyBanBannerResponse {
  temporarilyBanBanner: TemporarilyBanBannerPayload;
}

@Injectable({
  providedIn: 'root'
})
export class TemporarilyBanBannerGqlService extends Mutation<
  TemporarilyBanBannerResponse,
  MutationTemporarilyBanBannerArgs
> {
  override document = gql`
    mutation TemporarilyBanBanner($input: TemporarilyBanBannerInput!, $localization: LocalizationInput!) {
      temporarilyBanBanner(input: $input, localization: $localization) {
        journeyId
      }
    }
  `;
}
